import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Wrapper = styled.div<{ $spacing?: 'default' | 'large' }>`
  display: flex;
  align-items: center;
  gap: ${space['space-300']};
  padding: ${(p) => (p.$spacing === 'large' ? space['space-800'] : space['space-400'])} 0;
`;

export const Line = styled.div`
  flex: 1;
  height: ${size.stroke['stroke-default']};
  background: ${semantic.border.default};
`;

export const Text = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.secondary};
  flex-shrink: 0;
`;
